import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Plane, Users, FileText, LogOut, Calendar, Hotel, PartyPopper, Wine } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminEmail = localStorage.getItem('adminEmail');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminEmail');
    navigate('/admin/login');
  };

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: Plane, label: 'Gestion des Vols', path: '/admin/flights' },
    { icon: Hotel, label: 'Gestion des Séjours', path: '/admin/stays' },
    { icon: PartyPopper, label: 'Gestion des Événements', path: '/admin/events' },
    { icon: Wine, label: 'Gestion des After-Works', path: '/admin/afterworks' },
    { icon: Users, label: 'Gestion des Membres', path: '/admin/members' },
    { icon: Calendar, label: 'Réservations', path: '/admin/bookings' },
    { icon: FileText, label: 'Demandes de Devis', path: '/admin/quotes' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-secondary)' }}>
      {/* Sidebar */}
      <div style={{
        width: '260px',
        background: 'var(--bg-primary)',
        borderRight: '1px solid var(--border-light)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{ padding: '24px', borderBottom: '1px solid var(--border-light)' }}>
          <h2 className="heading-1" style={{ marginBottom: '4px' }}>Admin H&G</h2>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>{adminEmail}</p>
        </div>

        {/* Menu */}
        <nav style={{ flex: 1, padding: '16px' }}>
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  marginBottom: '4px',
                  textDecoration: 'none',
                  color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
                  background: isActive ? 'var(--bg-secondary)' : 'transparent',
                  border: isActive ? '1px solid var(--border-light)' : '1px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <Icon size={20} />
                <span className="body-regular">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div style={{ padding: '16px', borderTop: '1px solid var(--border-light)' }}>
          <button
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              width: '100%',
              padding: '12px 16px',
              background: 'transparent',
              border: '1px solid var(--border-light)',
              cursor: 'pointer',
              color: 'var(--text-secondary)'
            }}
          >
            <LogOut size={20} />
            <span className="body-regular">Déconnexion</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;